import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { showToast } from '@/utils';
import { bindRedemption, exchange } from '@/services/subscription';
import { getUserInfo } from '@/utils/user';
import { useAtom } from 'jotai';
import {
  curTabAtom,
  inviterUidAtom,
  rebateCodeAtom,
  resultModalTitleAtom,
  subEntranceBizCodeAtom,
  visibleExchangeAtom,
  visibleResultAtom,
} from '@/store';
import { isWeb } from '@/utils/vip';
import Tabs, { TabItem } from '../tabs';
import styles from './index.module.css';
import { track } from '@/utils/common';
import { TabType } from '@/constants/subscription';

enum ExchangeTabType {
  INVITE = 'invite',
  REDEEM = 'redeem',
}

const EXCHANGE_TABS: TabItem[] = [
  {
    name: '邀请码',
    key: ExchangeTabType.INVITE,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13.6693 2.66602C14.7738 2.66603 15.6693 3.56145 15.6693 4.66602V5.69499C15.6693 6.06315 15.3554 6.34957 15.027 6.51595C14.501 6.78239 14.1361 7.36597 14.1361 8.04297C14.1361 8.7199 14.5011 9.30324 15.027 9.56966C15.3554 9.73604 15.6693 10.0225 15.6693 10.3906V10.9993C15.6693 11.0187 15.6688 11.3713 15.6683 11.3906C15.6376 12.4684 14.7544 13.3327 13.6693 13.3327H8.66927V11.8327C8.66927 11.5565 8.44541 11.3327 8.16927 11.3327C7.89313 11.3327 7.66927 11.5565 7.66927 11.8327V13.3327H2.33594C1.25076 13.3327 0.367583 12.4684 0.336914 11.3906C0.336366 11.3713 0.335938 11.0187 0.335938 10.9993V10.3906C0.335945 10.0225 0.649762 9.73604 0.97819 9.56966C1.50414 9.30324 1.86908 8.7199 1.86914 8.04297C1.86914 7.36597 1.50418 6.78239 0.97819 6.51595C0.64976 6.34957 0.335938 6.06315 0.335938 5.69499V4.66602C0.335938 3.56145 1.23138 2.66603 2.33594 2.66602H7.66927V4.16602C7.66927 4.44216 7.89313 4.66602 8.16927 4.66602C8.44541 4.66602 8.66927 4.44216 8.66927 4.16602V2.66602H13.6693ZM8.16927 8.33268C7.89313 8.33268 7.66927 8.55654 7.66927 8.83268V10.166C7.66927 10.4422 7.89313 10.666 8.16927 10.666C8.44541 10.666 8.66927 10.4422 8.66927 10.166V8.83268C8.66927 8.55654 8.44541 8.33268 8.16927 8.33268ZM8.16927 5.33268C7.89313 5.33268 7.66927 5.55654 7.66927 5.83268V7.16602C7.66927 7.44216 7.89313 7.66602 8.16927 7.66602C8.44541 7.66602 8.66927 7.44216 8.66927 7.16602V5.83268C8.66927 5.55654 8.44541 5.33268 8.16927 5.33268Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: '兑换码',
    key: ExchangeTabType.REDEEM,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00261 2.84898C7.44579 1.79442 6.609 1.25692 5.74856 1.17751C4.6442 1.07558 3.50261 1.79741 3.50261 3.00485C3.50261 3.31313 3.56955 3.59295 3.71007 3.83415L3.15075 3.83415C2.93326 3.83414 2.74075 3.83413 2.58123 3.84716C2.41134 3.86104 2.23532 3.89216 2.06395 3.97947C1.81307 4.1073 1.6091 4.31128 1.48126 4.56216C1.39395 4.73352 1.36283 4.90955 1.34895 5.07943C1.33592 5.23895 1.33593 5.43143 1.33594 5.64892V5.686C1.33593 5.90348 1.33592 6.09601 1.34895 6.25553C1.36283 6.42541 1.39395 6.60144 1.48126 6.7728C1.6091 7.02369 1.81307 7.22766 2.06395 7.35549C2.23532 7.44281 2.41134 7.47392 2.58123 7.4878C2.74076 7.50084 2.93325 7.50083 3.15076 7.50082H12.8545C13.072 7.50083 13.2645 7.50084 13.424 7.4878C13.5939 7.47392 13.7699 7.44281 13.9413 7.35549C14.1921 7.22766 14.3961 7.02369 14.5239 6.7728C14.6113 6.60144 14.6424 6.42541 14.6563 6.25553C14.6693 6.09602 14.6693 5.90354 14.6693 5.68607V5.64895C14.6693 5.43148 14.6693 5.23895 14.6563 5.07943C14.6424 4.90955 14.6113 4.73352 14.5239 4.56216C14.3961 4.31128 14.1921 4.1073 13.9413 3.97947C13.7699 3.89216 13.5939 3.86104 13.424 3.84716C13.2645 3.83413 13.072 3.83414 12.8545 3.83415H12.2951C12.4357 3.59295 12.5026 3.31313 12.5026 3.00485C12.5026 1.79741 11.361 1.07558 10.2567 1.17751C9.39621 1.25692 8.55942 1.79442 8.00261 2.84898ZM5.65665 2.17328C6.19699 2.22315 6.92124 2.62829 7.34372 3.83292C6.43818 3.82784 5.7292 3.8029 5.21809 3.68157C4.91081 3.60862 4.73776 3.51366 4.64313 3.41931C4.56434 3.34076 4.50261 3.2265 4.50261 3.00485C4.50261 2.55055 4.96101 2.10907 5.65665 2.17328ZM11.5026 3.00485C11.5026 3.2265 11.4409 3.34076 11.3621 3.41931C11.2675 3.51366 11.0944 3.60862 10.7871 3.68157C10.276 3.8029 9.56703 3.82784 8.66149 3.83292C9.08397 2.62829 9.80822 2.22315 10.3486 2.17328C11.0442 2.10907 11.5026 2.55055 11.5026 3.00485Z"
          fill="currentColor"
        />
        <path
          d="M2.16927 11.3223V8.43913C2.29141 8.4638 2.40343 8.47669 2.49979 8.48457C2.70152 8.50105 2.93202 8.50097 3.13242 8.50091L7.00261 8.5009V15.0009H5.84786C5.30597 15.0009 4.8689 15.0009 4.51496 14.972C4.15054 14.9422 3.83044 14.8793 3.5343 14.7284C3.06389 14.4887 2.68144 14.1063 2.44176 13.6359C2.29086 13.3397 2.22796 13.0196 2.19818 12.6552C2.16926 12.3013 2.16927 11.8642 2.16927 11.3223Z"
          fill="currentColor"
        />
        <path
          d="M9.00261 15.0009V8.5009L12.8728 8.50091C13.0732 8.50097 13.3037 8.50105 13.5054 8.48457C13.6018 8.47669 13.7138 8.4638 13.8359 8.43913V11.3223C13.8359 11.8642 13.8359 12.3013 13.807 12.6552C13.7773 13.0196 13.7143 13.3397 13.5635 13.6359C13.3238 14.1063 12.9413 14.4887 12.4709 14.7284C12.1748 14.8793 11.8547 14.9422 11.4903 14.972C11.1363 15.0009 10.6992 15.0009 10.1574 15.0009H9.00261Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

interface IProps {
  /**
   * 刷新商品列表
   */
  onRefresh?: () => void;
}
const Exchange: React.FC<IProps> = ({ onRefresh }) => {
  const [exchangeTab, setExchangeTab] = useState<ExchangeTabType>(ExchangeTabType.INVITE);
  const [exchangeCode, setExchangeCode] = useState('');
  const [exchangeLoading, setExchangeLoading] = useState(false);

  const [, setResultModalTitle] = useAtom(resultModalTitleAtom);
  const [, setVisibleResult] = useAtom(visibleResultAtom);
  const [, setRebateCode] = useAtom(rebateCodeAtom);
  const [, setInviterUid] = useAtom(inviterUidAtom);
  const [, setVisibleExchange] = useAtom(visibleExchangeAtom);
  const [, setSubEntranceBizCode] = useAtom(subEntranceBizCodeAtom);
  const [, setCurTab] = useAtom(curTabAtom);

  const moduleRef = useRef<HTMLDivElement>(null);

  // 邀请码兑换
  const handleInviteExchangeFn = async () => {
    const value = exchangeCode.trim();
    try {
      setExchangeLoading(true);
      const res = await bindRedemption(value);
      setExchangeLoading(false);

      if (res?.data?.code === 0) {
        await getUserInfo();
        showToast(res?.data?.data.msg || '兑换成功~', moduleRef.current);

        // 更新邀请码
        setRebateCode(res.data.data.rebate_code || '');
        setInviterUid(res.data.data.inviter_uid || '');
        if (res.data.data.subscribe_entry) {
          // 更新商品入口标识
          setSubEntranceBizCode(res.data.data.subscribe_entry);
        }

        const benefit_type = res.data.data.benefit_type;

        setExchangeCode('');

        if (res.data.data.benefit_type === 1) {
          // 订阅优惠场景
          // 切到购买基础会员tab
          setCurTab(TabType.SUB);
          // 退出到优惠商品购买页面
          setVisibleExchange(false);
        }

        // 刷新商品列表生成新的二维码
        onRefresh?.();

        track({
          event_id: 'invite_exchange_success',
          event_name: '邀请码兑换成功',
          params: {
            exchange_type: benefit_type === 1 ? 'subscribe' : 'gift',
          },
        });
      } else {
        showToast(res?.data?.message || '兑换失败，请稍后再试~', moduleRef.current);
      }
    } catch (e) {
      showToast('兑换失败，请稍后再试~', moduleRef.current);
    } finally {
      setExchangeLoading(false);
    }
  };

  // 兑换码兑换
  const handleExchangeFn = async () => {
    const value = exchangeCode.trim();
    try {
      setExchangeLoading(true);
      const res = await exchange(value);
      setExchangeLoading(false);

      if (res?.data?.code === 0) {
        await getUserInfo();
        setResultModalTitle(
          isWeb ? '您已成功兑换美图设计室VIP会员!' : '您已成功兑换美图秀秀SVIP会员!'
        );
        setVisibleResult(true);
        setExchangeCode('');
      } else {
        showToast(res?.data?.message || '兑换失败，请稍后再试~', moduleRef.current);
      }
    } catch (e) {
      showToast('兑换失败，请稍后再试~', moduleRef.current);
    } finally {
      setExchangeLoading(false);
    }
  };

  const handleExchangeSubmit = async () => {
    if (exchangeLoading) return;
    const value = exchangeCode.trim();

    if (!value) {
      const tipText = exchangeTab === ExchangeTabType.INVITE ? '请输入邀请码' : '请输入兑换码';
      showToast(tipText, moduleRef.current);
      return;
    }

    if (exchangeTab === ExchangeTabType.INVITE) {
      handleInviteExchangeFn();
    } else {
      handleExchangeFn();
    }
  };

  const isInvite = exchangeTab === ExchangeTabType.INVITE;

  return (
    <div className={styles.exchangeBody} ref={moduleRef}>
      {/* 上半部分：标题 + 输入区域 */}
      <div className={styles.exchangeCenterSection}>
        <div className={styles.exchangeTitleGroup}>
          <div className={styles.exchangeTitle}>优惠码中心</div>
          <div className={styles.exchangeSubtitle}>选择您持有的码类型进行验证兑换</div>
        </div>

        <div className={styles.exchangeInputGroup}>
          <Tabs
            tabs={EXCHANGE_TABS}
            value={exchangeTab}
            onChange={(key) => {
              setExchangeTab(key as ExchangeTabType);
              setExchangeCode('');
            }}
            size="large"
          />
          <div className={styles.exchangeInputRow}>
            <input
              className={styles.exchangeInputField}
              type="text"
              placeholder={isInvite ? '请输入邀请码' : '请输入兑换码'}
              value={exchangeCode}
              maxLength={50}
              disabled={exchangeLoading}
              onChange={(e) => setExchangeCode(e.target.value)}
            />
            <button
              className={classnames(styles.exchangeSubmitBtn, {
                [styles.exchangeSubmitBtnDisabled]: exchangeLoading,
              })}
              onClick={handleExchangeSubmit}
              disabled={exchangeLoading}
            >
              立即兑换
            </button>
          </div>
        </div>
      </div>

      {/* 下半部分：说明区域 */}
      <div className={styles.exchangeDescSection}>
        <div className={styles.exchangeDivider} />
        <div className={styles.exchangeDescContent}>
          <div className={styles.exchangeDescTitle}>{isInvite ? '邀请码说明' : '兑换码说明'}</div>
          <div className={styles.exchangeDescText}>
            {isInvite ? (
              <>
                <p>用户输入从社交媒体等渠道获得的专属邀请码：</p>
                <ul className={styles.exchangeDescList}>
                  <li>专属渠道的优惠订阅价格，获得权益限免次数</li>
                  <li>每个邀请码仅限使用一次</li>
                  <li>不可与其他优惠活动叠加使用</li>
                </ul>
              </>
            ) : (
              <>
                <p>使用从官方渠道获得的会员兑换码：</p>
                <ul className={styles.exchangeDescList}>
                  <li>登录账号后，输入兑换码即可完成兑换</li>
                  <li>兑换成功后，可享受对应的会员权益和服务</li>
                  <li>请在兑换码有效期内使用，过期作废，不可退款</li>
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exchange;
